// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--NFt5O","navCont":"footer-module--nav-cont--2WVUX"};